module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("ku80M"))).then(() => module.bundle.root('hEqeo'));